import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assests/img/logo2.png';
import Topmenuleft from './Topmenuleft';
import Mobilemenu from './Mobilemenu';
import BackToTop from './BackToTop';
import { IoMdClose } from 'react-icons/io';
import { FaEnvelope, FaFacebook, FaInstagram, FaLinkedin, FaPhoneAlt, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { contactInfo } from '../data/siteNav';
import '../assests/css/header.css';

const socialIcons = {
  Facebook: FaFacebook,
  Instagram: FaInstagram,
  LinkedIn: FaLinkedin,
  X: FaXTwitter,
  YouTube: FaYoutube,
};

function Header() {
  const headerRef = React.useRef(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [isScrolled, setIsScrolled] = React.useState(false);
  const [headerHeight, setHeaderHeight] = React.useState(118);
  const closeMobileMenu = () => setIsMenuOpen(false);

  React.useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }

    return () => document.body.classList.remove('menu-open');
  }, [isMenuOpen]);

  React.useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  React.useEffect(() => {
    const el = headerRef.current;
    if (!el) return undefined;

    const updateHeight = () => setHeaderHeight(el.offsetHeight);
    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    observer.observe(el);
    return () => observer.disconnect();
  }, [isScrolled, isMenuOpen]);

  return (
    <>
      <header
        ref={headerRef}
        className={`eduya-header${isScrolled ? ' is-scrolled' : ''}`}
      >
      <div className="eduya-topbar">
        <div className="container eduya-topbar-inner">
          <div className="eduya-topbar-contacts">
            <span className="eduya-topbar-item">
              <span className="eduya-topbar-label">Sales :</span>
              <FaPhoneAlt />
              <a href={contactInfo.phoneHref}>{contactInfo.phone}</a>
            </span>
            <span className="eduya-topbar-item">
              <FaEnvelope />
              <a href={contactInfo.salesEmailHref}>{contactInfo.salesEmail}</a>
            </span>
            <span className="eduya-topbar-divider">|</span>
            <span className="eduya-topbar-item">
              <span className="eduya-topbar-label">Parent Help Desk (Mon-Fri) :</span>
              <FaEnvelope />
              <a href={contactInfo.parentDeskHref}>{contactInfo.parentDesk}</a>
            </span>
          </div>
          <div className="eduya-topbar-follow">
            <span>Follow Us:</span>
            <div className="eduya-topbar-social">
              {Object.entries(socialIcons).map(([label, Icon]) => (
                <a key={label} href="#" aria-label={label}>
                  <Icon />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="container eduya-header-inner">
        <Link to="/" className="eduya-logo" onClick={closeMobileMenu}>
          <img className="eduya-logo-img" src={logo} alt="Bright Study" />
        </Link>

        <Topmenuleft />

        <Link to="/register-for-demo" className="eduya-cta eduya-cta-desktop">
          Register for Demo
        </Link>

        <button
          type="button"
          className="eduya-menu-toggle"
          aria-label="Open menu"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen(true)}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 12L10 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20 5L4 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20 19L4 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>

      <div className={`eduya-drawer ${isMenuOpen ? 'is-open' : ''}`}>
        <div className="eduya-drawer-panel">
          <div className="eduya-drawer-top">
            <Link to="/" className="eduya-logo" onClick={closeMobileMenu}>
              <img className="eduya-logo-img" src={logo} alt="Bright Study" />
            </Link>
            <button
              type="button"
              className="eduya-menu-close"
              aria-label="Close menu"
              onClick={closeMobileMenu}
            >
              <IoMdClose />
            </button>
          </div>
          <Mobilemenu onClose={closeMobileMenu} />
        </div>
        </div>
      </header>
      <div className="eduya-header-spacer" style={{ height: headerHeight }} aria-hidden="true" />
      <BackToTop />
    </>
  );
}

export default Header;
